import React from 'react'
import { useLocation, useNavigate } from 'react-router'

import { exists, waitImmediate } from '~/utils'

export const useScrollEffect = (isReady: boolean) => {
  const location = useLocation()
  const navigate = useNavigate()

  React.useEffect(() => {
    if (!isReady) {
      return
    }

    const hash = location.state?.hash

    if (!exists(hash)) {
      return
    }

    waitImmediate().then(() => {
      document.getElementById(hash)?.scrollIntoView({ behavior: 'smooth' })
    })

    navigate(location.pathname, { replace: true })
  }, [navigate, isReady, location])
}
